module.exports = __webpack_public_path__ + "img/center front length from waist seam to hem.7b9c4b28.png";